module.exports = __webpack_public_path__ + "img/zeroFat.69fbd03b.png";